import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import KnowledgeHero from './components/KnowledgeHero';
import KnowledgeCategories from './components/KnowledgeCategories';
import KnowledgeArticles from './components/KnowledgeArticles';
import KnowledgeVideos from './components/KnowledgeVideos';
import KnowledgeCta from './components/KnowledgeCta';
import { useTitle } from '@/hooks/useTitle';

import PageCta from '@/components/feature/PageCta';

export default function Knowledge() {
  useTitle({
    title: '知識分享｜保險建築師醫療、長照、退休知識',
    description: '保險建築師知識分享專區，提供醫療保險、長期照護、退休規劃、保單健檢等深度文章與影片。',
  });
  return (
    <main>
      <Navbar />
      <KnowledgeHero />
      <KnowledgeCategories />
      <KnowledgeArticles />
      <KnowledgeVideos />
      <KnowledgeCta />
      <PageCta />
      <Footer />
    </main>
  );
}
